import { render, staticRenderFns } from "./jackPotNew.vue?vue&type=template&id=22c7cd2a&"
import script from "./jackPotNew.vue?vue&type=script&lang=js&"
export * from "./jackPotNew.vue?vue&type=script&lang=js&"
import style0 from "./jackPotNew.vue?vue&type=style&index=0&id=22c7cd2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports